var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"white","flat":""}},[_c('v-container',{staticClass:"mt-4"},[_c('v-row',{staticClass:"pa-5"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require('@/assets/img/timeline.png')}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }